import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import {
  AssureurType,
  RcpType,
} from '@lib/models/demande-validation-pj/piece-justificative-rcp.model';
import { DocumentFormBase } from '../document-form.base';
import { OuiDatePicker, OuiSelect, OuiValidationError } from 'omnium-ui/form-field';
import {
  assureurOptions,
  rcpMultiOptions,
} from '@lib/models/demande-validation-pj/document-form-rcp.model';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { DocumentsConsultantService } from '@lib/services/documents/documents-consultant.service';

@Component({
  selector: 'app-document-form-rcp',
  standalone: true,
  imports: [OuiSelect, OuiDatePicker],
  templateUrl: './document-form-rcp.component.html',
  styleUrl: './document-form-rcp.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentFormRcpComponent extends DocumentFormBase<RcpForm> {
  private readonly documentConsultantService = inject(DocumentsConsultantService);

  readonly assureurOptions = assureurOptions;
  readonly rcpMultiOptions = rcpMultiOptions;
  readonly statutJuridiquesConsultant = this.documentConsultantService.statutJuridiques;

  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  protected override createForm(fb: NonNullableFormBuilder) {
    return createRcpForm(fb);
  }

  constructor() {
    super();
    effect(() => {
      if (this.statutJuridiquesConsultant().length !== 0) {
        this.setStatutJuridiqueSelection();
      }
    });
  }

  private async setStatutJuridiqueSelection() {
    this.form
      .get('statutJuridique')
      ?.setValue(this.statutJuridiquesConsultant()?.map(st => st.id.toString()));
  }

  onAssureurChange(event: string) {
    if (event === '1') {
      this.form
        .get('rcpType')
        ?.setValue(this.rcpMultiOptions.map(rcp => rcp.value) as RcpType[]);
    }
  }
}

function createRcpForm(fb: NonNullableFormBuilder) {
  return fb.group({
    assureurId: fb.control<AssureurType | undefined>(undefined, [Validators.required]),
    rcpType: fb.control<RcpType[] | undefined>(undefined, [Validators.required]),
    statutJuridique: fb.control<string[] | undefined>([], [Validators.required]),
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
  });
}

export type RcpForm = ReturnType<typeof createRcpForm>;
export type RcpFormValue = RcpForm['value'];
